import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_whatsapp-background.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_trash.svg'
import _imports_2 from '@/app/ui/assets/svg/clock.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1e406ea5")

_pushScopeId("data-v-1e406ea5")
const _hoisted_1 = { class: "bg-white rounded-lg w-1/2 overflow-hidden" }
const _hoisted_2 = { class: "flex items-center justify-between p-4 border-b border-gray-200" }
const _hoisted_3 = { class: "text-xl font-semibold text-gray-lp-300" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_5 = { class: "flex flex-col p-4 text-sm" }
const _hoisted_6 = {
  class: "flex-1 overflow-y-auto h-40 custom-scrollbar",
  style: {"max-height":"300px"}
}
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = { class: "font-semibold text-gray-lp-300 mb-1" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "text-gray-lp-300" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-6 h-6"
}, null, -1)
const _hoisted_12 = { class: "flex items-center gap-4" }
const _hoisted_13 = { class: "flex flex-row text-right text-gray-lp-300 gap-2" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "font-medium" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-bold text-gray-lp-600" }, "•", -1)
const _hoisted_17 = {
  class: "font-bold",
  "data-testid": "pickup-dashboard-modal-assign-weight"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: " w-6 h-6"
}, null, -1)
const _hoisted_19 = { class: "flex-shrink-0 bg-white border-t border-gray-100" }
const _hoisted_20 = {
  key: 0,
  class: "p-4 bg-gray-lp-1600 rounded-b-xl"
}
const _hoisted_21 = { class: "flex items-center justify-between" }
const _hoisted_22 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_23 = { class: "text-right text-gray-lp-300 flex gap-2" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "font-normal" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-bold text-gray-lp-600" }, "•", -1)
const _hoisted_27 = {
  class: "font-bold",
  "data-testid": "pickup-dashboard-modal-assign-total-weight"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "w-8 h-8 ml-2" }, null, -1)
const _hoisted_29 = { class: "mb-4 mt-4 " }
const _hoisted_30 = { class: "block text-sm text-gray-lp-300 font-semibold mb-2" }
const _hoisted_31 = { class: "mb-4 mt-4 " }
const _hoisted_32 = { class: "flex flex-row justify-between items-center" }
const _hoisted_33 = { class: "text-sm text-gray-lp-300 font-semibold" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "grid grid-cols-2 gap-2 w-full"
}
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "text-xs font-semibold text-gray-lp-300" }
const _hoisted_38 = { class: "flex flex-col" }
const _hoisted_39 = { class: "text-xs font-semibold text-gray-lp-300" }
const _hoisted_40 = { class: "flex flex-row mt-2" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "\n                      flex justify-center -mr-0.5 rounded-l-md text-black-lp-300 text-center border border-gray-lp-1300 outline-none focus:shadow py-1.8 px-2.5\n                    " }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    class: "w-4 max-w-none",
    alt: "clock"
  })
], -1)
const _hoisted_42 = {
  key: 0,
  class: "text-center text-gray-lp-300 font-normal w-full py-3"
}
const _hoisted_43 = { class: "flex items-center justify-end gap-3 p-4 shadow-sm rounded-t-lg border-t border-gray-200" }
const _hoisted_44 = { class: "justify-center" }
const _hoisted_45 = { class: "text-xs font-medium text-gray-lp-300" }
const _hoisted_46 = { class: "max-h-100 overflow-y-auto custom-scrollbar" }
const _hoisted_47 = { class: "w-full mt-3" }
const _hoisted_48 = { class: "sticky top-0 bg-white z-10 text-sm text-gray-lp-300 font-semibold border-t border-b border-gray-lp-1400" }
const _hoisted_49 = { class: "py-2.5 w-12" }
const _hoisted_50 = { class: "px-3 flex justify-start" }
const _hoisted_51 = { class: "py-2.5 w-44" }
const _hoisted_52 = { class: "px-3 flex justify-start" }
const _hoisted_53 = { class: "py-2.5 w-44" }
const _hoisted_54 = { class: "px-3 flex justify-start" }
const _hoisted_55 = { class: "py-2.5 w-44" }
const _hoisted_56 = { class: "px-3 flex justify-start text-left" }
const _hoisted_57 = { class: "justify-end px-3 py-3 font-normal" }
const _hoisted_58 = { class: "text-left" }
const _hoisted_59 = { class: "text-left px-3 py-3" }
const _hoisted_60 = { class: "flex flex-col items-start gap-1" }
const _hoisted_61 = { class: "font-medium" }
const _hoisted_62 = { class: "flex flex-row gap-1" }
const _hoisted_63 = { class: "font-normal text-gray-lp-600" }
const _hoisted_64 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-4 h-4"
}, null, -1)
const _hoisted_65 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_66 = {
  class: "text-left px-3 py-3 font-normal",
  "data-testid": "pickup-dashboard-modal-assign-quantity"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "modal-manual-assign fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.isSingleSeller
              ? _ctx.$t("pickupDashboard.manualAssign")
              : _ctx.$t("pickupDashboard.multipleManualAssign")), 1),
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
              }, [
                _hoisted_4
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", {
                  class: ["space-y-2 bg-gray-lp-1000", `${_ctx.isSingleSeller ? 'rounded-xl' : 'rounded-t-xl'}`]
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localSelectedSellers, (seller, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: seller.id,
                      class: "flex items-center justify-between px-4 py-2 border-b border-gray-lp-1400"
                    }, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", _hoisted_8, _toDisplayString(seller.sellerName), 1),
                        _createVNode("div", _hoisted_9, [
                          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.formatPhoneNumber(seller.sellerPhone)), 1),
                          _createVNode("a", {
                            href: `https://wa.me/${_ctx.waNumber(seller.sellerPhone)}`,
                            target: "_blank",
                            class: "flex items-center justify-center"
                          }, [
                            _hoisted_11
                          ], 8, ["href"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_12, [
                        _createVNode("div", _hoisted_13, [
                          _createVNode("span", _hoisted_14, _toDisplayString(_ctx.fmtQty(seller.packageCount)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.package")), 1),
                          _createVNode("span", _hoisted_15, "(" + _toDisplayString(_ctx.fmtQty(seller.koli)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ")", 1),
                          _hoisted_16,
                          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.fmtWeight(seller.weight)), 1)
                        ]),
                        (!_ctx.isSingleSeller)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.removeSeller(index)),
                              class: "w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full"
                            }, [
                              _hoisted_18
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ], 2)
              ]),
              _createVNode("div", _hoisted_19, [
                (!_ctx.isSingleSeller)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("pickupDashboard.totalSender")) + " (" + _toDisplayString(_ctx.totalSenders) + ")", 1),
                        _createVNode("div", _hoisted_23, [
                          _createVNode("span", _hoisted_24, _toDisplayString(_ctx.fmtQty(_ctx.totalPackages)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.package")), 1),
                          _createVNode("span", _hoisted_25, "(" + _toDisplayString(_ctx.fmtQty(_ctx.totalKoli)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ")", 1),
                          _hoisted_26,
                          _createVNode("span", _hoisted_27, _toDisplayString(_ctx.fmtWeight(_ctx.totalWeight)), 1),
                          _hoisted_28
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_29, [
                  _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("pickupDashboard.selectCourier")), 1),
                  _createVNode(_component_SelectSearch, {
                    options: _ctx.courierOptions,
                    modelValue: _ctx.selectedCourier,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedCourier = $event)),
                    isLoading: _ctx.isLoadingCouriers,
                    placeholder: _ctx.$t('pickupDashboard.selectCourierPlaceholder'),
                    keyName: "name",
                    keyValue: "value",
                    maxHeight: "120px",
                    onChange: _ctx.onSelectCourier,
                    onFilter: _ctx.filterAvailableCouriers,
                    onClose: _ctx.onCloseCourierSelect
                  }, null, 8, ["options", "modelValue", "isLoading", "placeholder", "onChange", "onFilter", "onClose"])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("pickupDashboard.scheduleAssign")), 1),
                    _createVNode("div", {
                      id: "toggle_booking_instant_create_shipment",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChangeToggle && _ctx.onChangeToggle(...args))),
                      class: 
                  `toggle-switch inline-block cursor-pointer ${
                    _ctx.isSetSchedule
                      ? `toggle-active ${'bg-red-lp-100'}`
                      : `${'bg-gray-lp-200'}`
                  }`
                
                    }, [
                      _hoisted_34
                    ], 2)
                  ]),
                  (_ctx.isSetSchedule)
                    ? (_openBlock(), _createBlock("div", _hoisted_35, [
                        _createVNode("div", _hoisted_36, [
                          _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("pickupDashboard.date")), 1),
                          _createVNode(_component_DatePicker, {
                            class: "my-2",
                            modelValue: _ctx.assignDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.assignDate = $event)),
                            minDate: new Date(),
                            dateIconBackground: "border-gray-lp-1300",
                            placeholder: _ctx.$t('pickupDashboard.selectDate')
                          }, null, 8, ["modelValue", "minDate", "placeholder"])
                        ]),
                        _createVNode("div", _hoisted_38, [
                          _createVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("pickupDashboard.time")), 1),
                          _createVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createVNode(_component_CustomDropdown, {
                              isExpand: _ctx.timePickerOpen,
                              "onUpdate:isExpand": _cache[5] || (_cache[5] = ($event: any) => (_ctx.timePickerOpen = $event)),
                              options: _ctx.generateTimeSlots,
                              onSelect: _ctx.onSelectTime,
                              placeholder: _ctx.$t('pickupDashboard.selectTime'),
                              class: "w-full",
                              isCustomWidth: "",
                              isCustomMaxHeight: "",
                              selectedItem: _ctx.assignTime,
                              customBorderColor: "border-gray-lp-1300",
                              customValueStyle: "text-sm"
                            }, {
                              default: _withId(() => [
                                (_ctx.generateTimeSlots.length === 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_42, _toDisplayString(_ctx.$t("pickupDashboard.noTimeOptions")), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_43, [
              _createVNode("button", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleAssign && _ctx.handleAssign(...args))),
                disabled: _ctx.disableAssign,
                class: ["px-6 py-2 text-white rounded-lg", 
            `${
              _ctx.disableAssign ? 'bg-gray-300 cursor-not-allowed' : 'bg-red-lp-100'
            }`
          ],
                style: {"width":"200px"}
              }, _toDisplayString(_ctx.$t("pickupDashboard.assign")), 11, ["disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalAssign,
      title: _ctx.$t('pickupDashboard.manualAssignSuccessTitle'),
      message: _ctx.$t('pickupDashboard.manualAssignSuccessMessage'),
      image: "ill_badge_success",
      textSuccess: _ctx.$t('pickupDashboard.manageArea.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalAssign,
      title: _ctx.$t('pickupDashboard.manualAssignFailedTitle'),
      message: _ctx.errorMessage,
      image: "circle-error",
      textSuccess: _ctx.$t('pickupDashboard.manageArea.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openError]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalAssign,
      title: _ctx.$t('pickupDashboard.manualAssignFailedTitle'),
      image: "badge-warning-lg",
      textSuccess: _ctx.$t('pickupDashboard.manageArea.ok'),
      class: "px-8",
      customWidth: "600px"
    }, {
      custom: _withId(() => [
        _createVNode("div", _hoisted_44, [
          _createVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("pickupDashboard.manualAssignPartialMessage", {
              count: _ctx.errorAssignData.length
            })), 1),
          _createVNode("div", _hoisted_46, [
            _createVNode("table", _hoisted_47, [
              _createVNode("thead", _hoisted_48, [
                _createVNode("th", _hoisted_49, [
                  _createVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("pickupDashboard.column.no")), 1)
                ]),
                _createVNode("th", _hoisted_51, [
                  _createVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("pickupDashboard.column.senderName")), 1)
                ]),
                _createVNode("th", _hoisted_53, [
                  _createVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("pickupDashboard.column.shipmentType")), 1)
                ]),
                _createVNode("th", _hoisted_55, [
                  _createVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("pickupDashboard.column.totalShipment")), 1)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errorAssignData, (item, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: `pickup-shipment-${index}`,
                    class: "border-t border-b border-gray-lp-1400 text-sm text-gray-lp-300"
                  }, [
                    _createVNode("td", _hoisted_57, [
                      _createVNode("div", _hoisted_58, _toDisplayString(index + 1), 1)
                    ]),
                    _createVNode("td", _hoisted_59, [
                      _createVNode("div", _hoisted_60, [
                        _createVNode("span", _hoisted_61, _toDisplayString(item.senderName), 1),
                        _createVNode("div", _hoisted_62, [
                          _createVNode("span", _hoisted_63, _toDisplayString(_ctx.formatPhoneNumber(item.senderPhone)), 1),
                          _createVNode("a", {
                            href: `https://wa.me/${_ctx.waNumber(item.senderPhone)}`,
                            target: "_blank",
                            class: "flex items-center justify-center"
                          }, [
                            _hoisted_64
                          ], 8, ["href"])
                        ])
                      ])
                    ]),
                    _createVNode("td", _hoisted_65, _toDisplayString(_ctx.mapShipmentType(item.shipmentType)), 1),
                    _createVNode("td", _hoisted_66, _toDisplayString(_ctx.fmtQty(item.totalShipment)) + " (" + _toDisplayString(_ctx.fmtQty(item.totalQuantity)) + ") ", 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "title", "textSuccess"]), [
      [_vShow, _ctx.openPartial]
    ])
  ], 64))
})